<template>
  <ShopifyDispatch v-if="SHOPIFYBRANDS.includes(BRAND)"></ShopifyDispatch>
  <OpenCartDispatch v-else></OpenCartDispatch>
</template>

<script>
import { ShopifyDispatch, OpenCartDispatch } from "./partials";
export default {
  name: "dispatch",
  components: { ShopifyDispatch, OpenCartDispatch }
};
</script>
